import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'

import type { IDataUpdateRepository } from '../domain/IDataUpdateRepository';



import { IServiceDataUpdate } from './IServiceDataUpdate';
import { dataUpdate } from '../domain/dataUpdate';
import { DataUpdateResult } from '../domain/dataUpdateResult';




@injectable()
export class DataUpdateService implements IServiceDataUpdate {
  private readonly repo: IDataUpdateRepository

  public constructor (@inject(TYPES.CONFIG_UPDATEDATA) _repo: IDataUpdateRepository) {
    this.repo = _repo
  }

  async update (applicationId:number, applicationVersion:number,componentId:number,componentDataSourceId:number,data: dataUpdate[],transactionOperation:boolean): (Promise<DataUpdateResult[]>) {
    return await this.repo.update(applicationId,applicationVersion, componentId,componentDataSourceId, data,transactionOperation);
  }

}
